import HeroBanner from "../../components/test/HeroBanner";

const TestPage = () => {
  return (
    <div className="container-fluid p-0">
      <HeroBanner />
    </div>
  );
};

export default TestPage;
